import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const AIRPORTS = ["KTEB","EGLL","OMDB","KPWK","LFPB","KLAS","VHHH","KASE","KVNY","OMDW","LSGG","RJTT","KHPN","KDAL","SBSP","KOPF","KMIA","KJFK","LFPG","EDDF"];

// Weather-tone → tailwind-safe colors matching the HUD palette.
// Brightened for better readability on the darkened ticker background.
const TONE_STYLES = {
  green:  { text: "#5FE895", dot: "#2ED573", label: "VFR" },
  yellow: { text: "#FFD86B", dot: "#F4C443", label: "MVFR/IFR" },
  red:    { text: "#FF7A7A", dot: "#EB5757", label: "IFR" },
  purple: { text: "#C99BFF", dot: "#B47CFF", label: "SNOW" },
  gray:   { text: "rgba(180,210,255,0.92)", dot: "rgba(120,180,255,0.75)", label: "—" },
};

export default function AirportTicker() {
  const [wx, setWx] = useState({});

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await api.get(`/weather/batch/${AIRPORTS.join(",")}`);
        if (alive) setWx(r.data || {});
      } catch { /* keep silent */ }
    };
    load();
    // refresh every 10 min
    const iv = setInterval(load, 10 * 60 * 1000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  return (
    <div className="relative border-y border-white/[0.08] py-2.5 overflow-hidden bg-black/70 backdrop-blur-md" data-testid="airport-ticker">
      <div className="flex gap-10 whitespace-nowrap" style={{ animation: "marquee 55s linear infinite" }}>
        {[...AIRPORTS, ...AIRPORTS, ...AIRPORTS].map((a, i) => {
          const info = wx[a];
          const tone = info?.tone || "gray";
          const style = TONE_STYLES[tone];
          const title = info?.raw ? `${a} · ${info.category || "—"}${info.has_snow ? " · SNOW" : info.has_rain ? " · RAIN" : ""} — ${info.raw.slice(0, 60)}…` : `${a} · METAR loading…`;
          return (
            <Link
              key={i}
              to={`/airports/${a}`}
              data-testid={i < AIRPORTS.length ? `ticker-${a}` : undefined}
              title={title}
              className="mono text-[12px] font-semibold tracking-widest inline-flex items-center gap-3 hover:opacity-90 transition-opacity"
              style={{ color: style.text, textShadow: "0 0 6px rgba(0,0,0,0.6)" }}
            >
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: style.dot, boxShadow: tone !== "gray" ? `0 0 6px ${style.dot}` : "none" }} />
              {a}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
